import React, { useEffect, useState } from "react";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import MyChartContainer from "./MyChartContainer";
import { MyChartHeading } from "../ecosystem/mybswh";

const AccountSummary = (props) => {
    const { proxyName } = Tools.getProxyName();
    const bswMatch = ".card";
    const events = [{ elements: "main .button", eventName: "click", message: "touched" }];
    const heading = (
        <MyChartHeading heading="Bill Pay" proxyName={proxyName} />
    );
    logUI("MBHWeb.UI.AccountSummary.ComponentDidMount", new Date(), Tools.getURLPath());
    return <MyChartContainer mode="accountsummary" title="Billing"
        events={events}
        bswMatch={bswMatch}
        heading={heading}
        onMessage={doEventMatch}

    />;
};
const doEventMatch = (event) => {
    console.info('AccountSummary doEventMatch XXX', event);
    const evt = event.data.evt || event.data;
    console.info('AccountSummary doEventMatch evt', evt);
    if (evt && evt.message === "touched") {
        //currently MyChartDataTile is looking for touched and reacting. May not need to do anything here.

    } else {
        console.info(`AccountSummary doEventMatch, NO EVENTS MATCHED`, event, event.data);
    }
}
export default AccountSummary;